"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Suggestions = void 0;
var $ = require("jquery");
var AuthHelper_1 = require("./AuthHelper");
var Suggestions = (function () {
    function Suggestions() {
    }
    Suggestions.prototype.setupPage = function (loggedIn, admin) {
        var _this = this;
        var staticTitle = $("#staticTitle");
        staticTitle.on("click", function (t) {
            $("#originalTitleContainer").css("display", "none");
            $("#editTitleContainer").css("display", "");
            $("#titleSuggestionSubmit").on("click", _this.submitTitleSuggestion);
        });
    };
    Suggestions.prototype.submitTitleSuggestion = function () {
        console.log('Submitting form...');
        $.ajax({
            type: 'POST',
            url: '/Photo/SuggestTitle',
            contentType: 'application/x-www-form-urlencoded',
            data: {
                photoId: globalPhotoId,
                suggestedTitle: $("#titleSuggestion").val()
            },
            success: function (result) {
                console.log('Data received: ');
                console.log(result);
                var titleSuggestionSubmit = $("#titleSuggestionSubmit");
                titleSuggestionSubmit.text("Done!");
                titleSuggestionSubmit.addClass("btn-outline-primary");
                titleSuggestionSubmit.removeClass("btn-outline-danger");
            },
            error: function () {
                var titleSuggestionSubmit = $("#titleSuggestionSubmit");
                titleSuggestionSubmit.text("Error");
                titleSuggestionSubmit.removeClass("btn-outline-primary");
                titleSuggestionSubmit.addClass("btn-outline-danger");
            }
        });
    };
    return Suggestions;
}());
exports.Suggestions = Suggestions;
$(function () {
    var suggesstions = new Suggestions();
    AuthHelper_1.AuthHelper.registerAuthHandler(function (loggedIn, isAdmin) {
        suggesstions.setupPage(loggedIn, isAdmin);
    });
});

//# sourceMappingURL=Suggestions.js.map
